export default {"src":"/_next/static/media/play.3ef7cce9.svg","height":88,"width":88};